import { useContext } from 'react'
import UserContext from './UserContext'
import { UserProvider } from './type'

export const useUserContextProvider = (): UserProvider => {
  return useContext(UserContext)
}
